import React from "react";
import { Link } from "react-router-dom";
import "../Styles/Home.css";
import "../Styles/ContactSection.css";
import aboutUsImage from "../Images/about_us.jpg";
import cncvideo from "../Videos/cnc-intro-video.mp4";
import Footer from "./Footer";

function ContactSection() {
  return (
    <div className="contact-us">
      <div className="contact-us-inner">
        <div className="contact-us-left">
          <p className="contact-us-eyebrow">Get In Touch</p>
          <h2 className="contact-us-heading">Let's build something<br />precise together.</h2>
          <div className="contact-us-items">
            <div className="contact-us-item">
              <span className="contact-us-icon">📍</span>
              <div>
                <span className="contact-us-label">Address</span>
                <span className="contact-us-value">6240 Hawthorne Drive, Windsor, ON N8T 1J9, Canada</span>
              </div>
            </div>
            <div className="contact-us-item">
              <span className="contact-us-icon">📞</span>
              <div>
                <span className="contact-us-label">Phone</span>
                <span className="contact-us-value">+1 519 800-8080</span>
              </div>
            </div>
            <div className="contact-us-item">
              <span className="contact-us-icon">✉️</span>
              <div>
                <span className="contact-us-label">Email</span>
                <a href="mailto:info@precisionworks.ca" className="contact-us-value contact-us-link">info@precisionworks.ca</a>
              </div>
            </div>
          </div>
          <a href="/contact" className="contact-us-cta">Send Us a Message</a>
        </div>
        <div className="contact-us-map">
          <iframe
            title="Google Maps Locator"
            src="https://maps.google.com/maps?width=100%25&height=600&hl=en&q=6240+Hawthorne+Dr,+Windsor,+ON+N8T+1J9,+Canada&t=&z=16&ie=UTF8&iwloc=B&output=embed"
            style={{ width: "100%", height: "100%", border: 0, display: "block" }}
          ></iframe>
        </div>
      </div>
    </div>
  );
}

function Home() {
  return (
    <div className="home-container">
      <div className="video-container">
        <video className="cnc-intro-video" autoPlay muted loop preload="auto">
          <source src={cncvideo} type="video/mp4" />
        </video>
        <div className="video-overlay">
          <h1>PRECISION MACHINING EXCELLENCE</h1>
          <p>On-demand CNC machining for rapid prototyping and production parts — built to your exact specifications.</p>
          <Link to="/contact" className="hero-cta">Request a Quote</Link>
        </div>
      </div>

      <div className="about-us">
        <h2>ABOUT US</h2>
        <div className="section-divider"></div>
        <div className="about-us-flexcontainer">
          <img src={aboutUsImage} alt="About Us" className="about-us-pic" />
          <div className="about-us-text">
            <p>
              Windsor Precision Works Inc. is on-demand CNC machining for rapid prototyping and production parts,
              through a network of specialized, experienced, and thoroughly vetted local and global CNC machine shops.
              We advanced with a straightforward thought of serving clients with the best items at competitive cost.
              With over 2 decades of aggregate involvement in accurate machining and casting, we have the capability
              to meet all the client's needs. We have been a one halt arrangement for our regarded customers'
              fabricating prerequisites. Our column for victory lies in our continuous lock in in learning and
              actualizing more up to date innovation for consistent optimization of our items. We have been serving
              Oil &amp; Gas Hardware, Cable, Pumps, Structural and various engineering industries. With extensive
              experience working with Steel and non-ferrous materials, we specialize in steel machining and
              prototyping, as well as aluminum prototyping and machining.
            </p>
          </div>
        </div>
      </div>

      <ContactSection />
      <Footer />
    </div>
  );
}

export default Home;
